import { render, staticRenderFns } from "./agricult_product.vue?vue&type=template&id=0868dcc6&"
import script from "./agricult_product.vue?vue&type=script&lang=js&"
export * from "./agricult_product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports